module.exports = __webpack_public_path__ + "static/obj_1@2x-94ffad54e8a922af6f926a9c91941c76.png";